import { render, staticRenderFns } from "./DesignRow.vue?vue&type=template&id=b043305e&scoped=true&"
import script from "./DesignRow.vue?vue&type=script&lang=js&"
export * from "./DesignRow.vue?vue&type=script&lang=js&"
import style0 from "./DesignRow.vue?vue&type=style&index=0&id=b043305e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b043305e",
  null
  
)

export default component.exports